import { AlphanumericTypeInput } from '@/features/InvoiceReport/Edit/components/InvoiceTransaction/Components/CustomTransactionItems/AlphanumericTypeInput/AlphanumericTypeInput';
import { DateTypeInput } from '@/features/InvoiceReport/Edit/components/InvoiceTransaction/Components/CustomTransactionItems/DateTypeInput/DateTypeInput';
import { PulldownType } from '@/features/InvoiceReport/Edit/components/InvoiceTransaction/Components/CustomTransactionItems/PulldownType/PulldownType';
import { TextTypeInput } from '@/features/InvoiceReport/Edit/components/InvoiceTransaction/Components/CustomTransactionItems/TextTypeInput/TextTypeInput';
import { TransactionProperty } from '@/features/InvoiceReport/Edit/type';
import { ComponentType } from 'react';

type CustomTransactionItemsProps = {
  index: number;
  property: TransactionProperty;
};

export const CustomTransactionItems: Record<
  string,
  ComponentType<CustomTransactionItemsProps>
> = {
  pulldown: PulldownType,
  text: TextTypeInput,
  alphanumeric: AlphanumericTypeInput,
  date: DateTypeInput,
};
